import { AiFillGithub, AiOutlineLink } from "react-icons/ai";
import crypto from "./projects/crypto.png";
import wordle from "./projects/wordle.png";
import blog from "./projects/blog.png";
import netflix from "./projects/netflix.png";
import sqlgen from "./projects/sqlgen.png";
import vidquery from "./projects/vidquery.png";
import prompt from "./projects/prompt.png";
import journal from "./projects/journal.png";
import { useEffect, useState } from "react";
import MotionFromLeft from "./MotionFromLeft";
import MotionFromRight from "./MotionFromRight";

const Project = ({
  index,
  title,
  description,
  techUsed,
  githubLink,
  projectLink,
  image,
  width,
}) => {
  if (index % 2 !== 0) {
    return (
      <MotionFromLeft>
        <div className="sm:mx-10 mt-[100px]  md:ml-[4%] md:pl-10  w-[85%] title group sm:p-2 rounded-2xl hover:sm:shadow-cyan-950 hover:ease-in-out transition duration-1000 ease-in-out hover:transition hover:duration-1000 hover:shadow-[0_5px_50px_5px_rgba(0,0,0,0.1)]">
          {width > 1023 && (
            <div className="absolute w-[57%] mt-6 ml-6 justify-end items-end flex rounded-xl h-auto overflow-hidden z-10">
              <div className="bg-[#64ffda]/70 w-[55%] group-hover:opacity-0 group-hover:transition group-hover:duration-500 h-[100%] absolute opacity-50 "></div>
              <img src={image} className="w-[55%]  overflow-hidden" alt="/" />
            </div>
          )}

          <div className="flex flex-col h-full justify-between lg:py-[50px] gap-2 relative bg-transparent min-h-[300px] z-20">
            <div className="text-gray-200 font-semibold text-xl mb-3">
              {title}
            </div>
            <div className="bg-[#112240] text-[#8892b0] relative md:w-[50%] px-6 py-3 rounded-md text-start">
              {description}
            </div>
            <div className="flex bg-[#0a192f] sm:w-max sm:no-scrollbar sm:max-w-[55%] overflow-x-auto rounded-xl p-1 mt-4">
              {techUsed.map((tech, index) => (
                <img
                  key={index}
                  src={tech}
                  alt=""
                  className=" w-max flex mx-1"
                ></img>
              ))}
            </div>
            <div className="flex">
              <span className="m-3 text-gray-300 text-3xl hover:text-[#64ffda]">
                <a href={githubLink} target="_blank" rel="noopener noreferrer">
                  <AiFillGithub />
                </a>
              </span>
              <span className="m-3 text-gray-300 text-3xl hover:text-[#64ffda]">
                <a href={projectLink} target="_blank" rel="noopener noreferrer">
                  <AiOutlineLink />
                </a>
              </span>
            </div>
          </div>
        </div>
      </MotionFromLeft>
    );
  } else {
    return (
      <MotionFromRight>
        <div className="sm:mx-10 mt-[100px] h-max md:mr-[11%] md:px-10 md:ml-[4%] p-3 rounded-2xl hover:sm:shadow-cyan-950 hover:ease-in-out transition duration-1000 ease-in-out hover:transition hover:duration-1000 hover:shadow-[0_5px_50px_5px_rgba(0,0,0,0.1)] title group">
          {width > 1023 && (
            <div className="absolute w-[57%] rounded-xl mt-10 h-auto overflow-hidden z-10">
              <div className="bg-[#64ffda]/70 w-[58%] group-hover:opacity-0 group-hover:transition group-hover:duration-500 h-[100%] absolute opacity-50 "></div>
              <img
                src={image}
                className="w-[58%] bg-cover overflow-hidden"
                alt="/"
              />
            </div>
          )}

          <div className="flex flex-col h-full justify-between items-end lg:pt-[50px] gap-2 relative bg-transparent min-h-[300px] z-20">
            <div className="text-gray-200 font-semibold text-xl mb-3">
              {title}
            </div>
            <div className="bg-[#112240] text-[#8892b0] relative md:w-[50%] px-6 py-3 rounded-md text-start">
              {description}
            </div>
            <div className="flex bg-[#0a192f] sm:w-max sm:no-scrollbar sm:max-w-[55%] w-[95%] overflow-x-auto rounded-xl p-1 mt-4">
              {techUsed.map((tech, index) => (
                <img
                  key={index}
                  src={tech}
                  alt=""
                  className=" w-max flex mx-1"
                ></img>
              ))}
            </div>
            <div className="flex">
              <span className="m-3 text-gray-300 text-3xl hover:text-[#64ffda]">
                <a href={githubLink} target="_blank" rel="noopener noreferrer">
                  <AiFillGithub />
                </a>
              </span>
              <span className="m-3 text-gray-300 text-3xl hover:text-[#64ffda]">
                <a href={projectLink} target="_blank" rel="noopener noreferrer">
                  <AiOutlineLink />
                </a>
              </span>
            </div>
          </div>
        </div>
      </MotionFromRight>
    );
  }
};

const projects = [
  {
    title: "AI Journal App",
    description:
      "All-in-one solution for managing your personal diaries and gaining deep insights from your daily entries. Users can get live sentiment analysis generated by ChatGPT. This project utilizes serverless functions and Prisma for dynamic data fetching.",
    techUsed: [
      "https://img.shields.io/badge/Next.js-000000?style=for-the-badge&logo=nextdotjs&logoColor=white",
      "https://img.shields.io/badge/Planetscale-000000?style=for-the-badge&logo=planetscale&logoColor=white",
      "https://img.shields.io/badge/OpenAI-00DAAF?style=for-the-badge&logo=openai&logoColor=white",
      "https://img.shields.io/badge/ClerkAuth-000000?style=for-the-badge&logo=clerkauth&logoColor=white",
      // Add more shields if needed
    ],
    githubLink: "https://github.com/Gurjit11/AI-Journal-web-app",
    projectLink: "https://ai-journal-web-app.vercel.app/",
    image: journal, // Replace with the actual image URL or use a placeholder
  },
  {
    title: "PromptVerse",
    description:
      "PromptVerse is a web application that provides users with creative writing prompts to spark their imagination. Users can explore various writing prompts across different genres and themes to overcome writer's block and boost their creativity.",
    techUsed: [
      "https://img.shields.io/badge/next%20js-000000?style=for-the-badge&logo=nextdotjs&logoColor=white",
      "https://img.shields.io/badge/Serverless-000000?style=for-the-badge&logo=serverless&logoColor=white",
      "https://img.shields.io/badge/MongoDB-4EA94B?style=for-the-badge&logo=mongodb&logoColor=white",
      "https://img.shields.io/badge/Tailwind_CSS-38B2AC?style=for-the-badge&logo=tailwind-css&logoColor=white",
      "https://img.shields.io/badge/-%20OpenAI%20-00DAAF?style=for-the-badge&logo=openai&logoColor=white",
      "https://img.shields.io/badge/Dall_E-000000?style=for-the-badge&logo=dalle&logoColor=white",
    ],
    githubLink: "https://github.com/Gurjit11/PromptVerse",
    projectLink: "https://prompt-verse-phi.vercel.app/",
    image: prompt,
  },
  {
    title: "VideoQuery",
    description:
      "VideoQuery is a web application that allows users to ask questions about videos to AI using a single interface. Users can enter their video url, and the application transcribes the video and creates vector documents in Pinecone and fetches query related documents for OpenAI chatgpt to answer the Questions.",
    techUsed: [
      "https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB",
      "https://img.shields.io/badge/Flask-000000?style=for-the-badge&logo=flask&logoColor=white",
      "https://img.shields.io/badge/-%20OpenAI%20-00DAAF?style=for-the-badge&logo=openai&logoColor=white",
      "https://img.shields.io/badge/Pinecone-000000?style=for-the-badge&logo=pinecone&logoColor=white",
      "https://img.shields.io/badge/-Whisper-00DAAF?style=for-the-badge&logo=whisper&logoColor=white",
      "https://img.shields.io/badge/Tailwind_CSS-38B2AC?style=for-the-badge&logo=tailwind-css&logoColor=white",
    ],
    githubLink: "https://github.com/Gurjit11/VideoQuery",
    projectLink: "https://video-query-eight.vercel.app/",
    image: vidquery,
  },
  {
    title: "SQL Generator",
    description:
      "SQL Generator is a tool that automates the process of generating SQL queries using AI , it also contains an SQL visualizer which helps user create SQL queries visually.",
    techUsed: [
      "https://img.shields.io/badge/next%20js-000000?style=for-the-badge&logo=nextdotjs&logoColor=white",
      "https://img.shields.io/badge/Node%20js-339933?style=for-the-badge&logo=nodedotjs&logoColor=white",
      "https://img.shields.io/badge/Express%20js-000000?style=for-the-badge&logo=express&logoColor=white",
      "https://img.shields.io/badge/TypeScript-007ACC?style=for-the-badge&logo=typescript&logoColor=white",
      "https://img.shields.io/badge/-%20OpenAI%20-00DAAF?style=for-the-badge&logo=openai&logoColor=white",
    ],
    githubLink: "https://github.com/Gurjit11/Sql-query-generator",
    projectLink: "https://sql-query-generator-mu.vercel.app/",
    image: sqlgen,
  },

  {
    title: "Wordle Clone",
    description:
      "The Wordle clone was a fun project that I created to experiment with React and CSS. I used hooks to manage the game state it is complex and fun. To improve the user experience, I implemented an on-screen keyboard and also unlimited new words unlike original the Wordle game. Its Playable on mobile devices as well.",
    techUsed: [
      "https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB",
      "https://img.shields.io/badge/CSS3-1572B6?style=for-the-badge&logo=css3&logoColor=white",
      "https://img.shields.io/badge/firebase-ffca28?style=for-the-badge&logo=firebase&logoColor=black",
    ],
    githubLink: "https://github.com/Gurjit11/Wordle-Clone",
    projectLink: "https://harmonious-empanada-1b9cd4.netlify.app/",
    image: wordle,
  },
  {
    title: "Netflix Clone",
    description:
      "I created a responsive and visually appealing user interface. To improve user experience, Users can create a custom list of movies and share the link to the list with their friends and family.",
    techUsed: [
      "https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB",
      "https://img.shields.io/badge/Tailwind_CSS-38B2AC?style=for-the-badge&logo=tailwind-css&logoColor=white",
      "https://img.shields.io/badge/firebase-ffca28?style=for-the-badge&logo=firebase&logoColor=black",
      "https://img.shields.io/badge/Web_Share_API-000000?style=for-the-badge&logo=wedshareapi&logoColor=white",
    ],
    githubLink: "https://github.com/Gurjit11/Netflix",
    projectLink: "https://netflix-webapp-1d352.web.app/",
    image: netflix,
  },
  {
    title: "CryptoTracer",
    description:
      "CryptoTracer is a live cryptocurrency tracking website with detailed descriptions of popular coins and their past performance. To improve user experience, I added a search bar and the ability to save coins to a user's profile using Firebase.",
    techUsed: [
      "https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB",
      "https://img.shields.io/badge/Tailwind_CSS-38B2AC?style=for-the-badge&logo=tailwind-css&logoColor=white",
      "https://img.shields.io/badge/firebase-ffca28?style=for-the-badge&logo=firebase&logoColor=black",
      "https://img.shields.io/badge/CoinGecko_API-000000?style=for-the-badge&logo=coingeckoapi&logoColor=white",
    ],
    githubLink: "https://github.com/Gurjit11/CryptoTracer",
    projectLink: "https://cryptotracker2024.web.app/",
    image: crypto,
  },
  {
    title: "BlogEarth",
    description:
      "I collaborated with my team members who were working on the backend, and we successfully built a functional blogging platform in just 24 hours. As the team leader, I managed the team's progress of working efficiently towards our common goal.",
    techUsed: [
      "https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB",
      "https://img.shields.io/badge/firebase-ffca28?style=for-the-badge&logo=firebase&logoColor=black",
      "https://img.shields.io/badge/Tailwind_CSS-38B2AC?style=for-the-badge&logo=tailwind-css&logoColor=white",
    ],
    githubLink: "https://github.com/Gurjit11/Out-of-Bounds",
    projectLink: "https://devfolio.co/projects/blogearth-3313",
    image: blog,
  },
];

const Projects = () => {
  const [width, setWindowWidth] = useState(0);
  const noOfPosts = 5;
  const [length, setLength] = useState(noOfPosts);
  useEffect(() => {
    updateDimensions();

    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  const updateDimensions = () => {
    const width = window.innerWidth;
    setWindowWidth(width);
  };
  return (
    <div id="projects" className="ml-[8%] pb-6 overflow-clip">
      <span className="text-[#64ffda] text-xl">03. </span>
      <span className="text-gray-200 text-2xl title font-extrabold">
        Some Things I’ve Built
      </span>

      {projects.slice(0, length).map((project, index) => (
        <Project key={index} index={index} {...project} width={width} />
      ))}
      {length < projects.length ? (
        <p className="  flex w-full justify-center ">
          <span
            onClick={() =>
              setLength((prev) =>
                parseInt(projects.length - prev) / parseInt(noOfPosts) > 1
                  ? prev + noOfPosts
                  : projects.length
              )
            }
            className="text-[#64ffda] cursor-pointer mt-10 border-b text-xl sm:mr-24 mr-6 border-cyan-500"
          >
            More Projects
          </span>
        </p>
      ) : null}
    </div>
  );
};

export default Projects;
